const formValidation = [
  {
    fieldName: 'address',
    fieldNick: 'Dirección',
    isValid: val => {
      return val ? val !== undefined && val.length > 4 : false
    },
  },
  {
    fieldName: 'phone',
    fieldNick: 'Teléfono',
    isValid: val => {
      console.log(`val phone: ${val}`)
      if (!val) return false
      const casted = val && +val.replaceAll(' ', '').replace('+', '')
      const rslt = typeof casted === 'number' && casted.toString().length > 10
      console.log(`casted phone: ${casted}, rslt: ${rslt}`)
      return rslt
    },
  },
  {
    fieldName: 'occupation',
    fieldNick: 'Ocupación',
    isValid: val => {
      return val ? val !== undefined && val.length > 4 : false
    },
  },
]

export { formValidation }
